























import {Component, Prop, Vue} from 'vue-property-decorator';
import {BaseScenarioType, IBaseScenario} from '@/lib/types/IBaseScenario';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import {agencyStore, designStore, lccaStore, perRoadStore, projectStore} from '@/store/store';
import {DesignScenarioType, IDesignBaseScenario} from "@/modules/design/interfaces/shared";

@Component({
  components: {PxTextEntryBox, PxDropdown},
})
export default class ShareScenarioModal extends Vue {
  @Prop() scenario!: IBaseScenario;

  @Prop() modalId!: string;

  targetUser: string = ''

  errorText: string | null = null;


  submit() {
    this.errorText = null;
    // projectStore.createSharedScenario({scenario: this.scenario, targetUserEmail: this.targetUser})

    this.loadFullScenario()?.then(s => {
      projectStore.createSharedScenario({scenario: s, targetUserEmail: this.targetUser}).then(() => {
        this.$bvModal.hide(this.modalId)
      }).catch(reason => this.handleFailure(reason))
    }).catch(reason => reason ? reason : null)
  }

  loadFullScenario() {

    /*
    Load the entire representation of the scenario to be saved as a JSON blob in the shared scenarios table.
     */

    if (this.scenario.id === null) {
      return null
    }

    switch (this.scenario.scenarioType) {
      case BaseScenarioType.design: {
        const designScenario = this.scenario as IDesignBaseScenario;
        switch (designScenario.designScenarioType) {
          case DesignScenarioType.acOverlay:
            return designStore.loadCurrentAcOverlayScenario(this.scenario.id)
          case DesignScenarioType.asphalt:
            return designStore.loadCurrentAsphaltScenario(this.scenario.id)
          case DesignScenarioType.concrete:
            return designStore.loadCurrentConcreteScenario(this.scenario.id)
          case DesignScenarioType.porous:
            return designStore.loadCurrentPorousScenario(this.scenario.id)
        }
        break;
      }
      case BaseScenarioType.lcca:
        return lccaStore.loadCurrentScenario(this.scenario.id)
      case BaseScenarioType.perRoad:
        return perRoadStore.loadCurrentScenario(this.scenario.id)
      case BaseScenarioType.agencyCost:
        return agencyStore.loadCurrentScenario(this.scenario.id)
    }

    return null

  }

  handleResponse(response: any) {
    console.log(response);
  }

  handleFailure(reason: any) {
    console.log(Object.entries(reason));
    if (reason.response.status === 400) {
      this.errorText = `${reason.response.data.statusText}`;
    } else {
      this.errorText = `${reason.response.status}: ${reason.response.statusText}`;
    }
  }
}
